export default __webpack_public_path__ + "static/cover_768-8b9ce5f390c3ab90c8395b55c9c4cb5d.jpg";